import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgxEzModalService} from '../../../../../../shared/modules/ngx-ez-modal/ngx-ez-modal.service';
import {HttpClient} from '@angular/common/http';

@Component({
  templateUrl: 'lol-customization-modal.component.html',
  styleUrls: ['lol-customization-modal.component.scss']
})
export class LolCustomizationModalComponent implements OnInit, AfterViewInit {
  @Input() lang: string;
  @Input() type: string;
  @Input() game: string = '';
  @Input() extraServiceCharactersTax: number;

  public champions: { name: string }[] = [];
  public availableChampions: { name: string }[] = [];
  public currentSelectedChampions: string[] = [];
  public availableChampionsSearchString = '';


  @ViewChild('searchInput', {static: true}) public input: ElementRef;


  @Output() selected = new EventEmitter<void>();

  constructor(public modalService: NgxEzModalService, private http: HttpClient) { }

  ngOnInit(): void {
    this.http.get('/customer/available-characters/' + this.game).subscribe((resp: any) => {
      this.champions = resp;
      this.availableChampions = resp;
    });
  }

  filterChampions(event) {
    this.availableChampionsSearchString = event.target.value;
    this.availableChampions = this.champions.filter(el => el.name.toLowerCase()
      .indexOf(this.availableChampionsSearchString.toLowerCase()) > -1);
  }

  toggleChampionSelection(champion: string) {
    if (this.currentSelectedChampions.indexOf(champion) > -1) {
      this.currentSelectedChampions = this.currentSelectedChampions.filter(el => el !== champion);
    } else {
      this.currentSelectedChampions = [...this.currentSelectedChampions, champion];
    }

    this.input.nativeElement.value = '';
    this.filterChampions({target: {value: ''}});
    this.focusInput();
  }

  verifySelectedChampions() {
    this.selected.emit();
    this.modalService.closeOutletModals('customization');
  }

  focusInput() {
    this.input.nativeElement.focus();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.focusInput();
    }, 500);
  }
}